// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd/lib/grid';

import { CombinedState, LabelingRunData } from 'reducers';
import dimensions from 'utils/dimensions';
import RunItemComponent from './run-item';

export default function RunListComponent(): JSX.Element {
    const runs = useSelector((state: CombinedState) => state.labelingRuns.current);

    const groupedRuns = runs.reduce(
        (acc: LabelingRunData[][], run: LabelingRunData, index: number): LabelingRunData[][] => {
            if (index && index % 4) {
                acc[acc.length - 1].push(run);
            } else {
                acc.push([run]);
            }
            return acc;
        },
        [],
    );

    return (
        <Row justify='center' align='middle' className='cvat-labeling-runs-list-content'>
            <Col {...dimensions}>
                {groupedRuns.map((group) => (
                    <Row key={group[0].id}>
                        {group.map((run) => (
                            <Col span={6} key={run.id}>
                                <RunItemComponent run={run} />
                            </Col>
                        ))}
                    </Row>
                ))}
            </Col>
        </Row>
    );
}
